import { render, staticRenderFns } from "./CustomReportsCrud.vue?vue&type=template&id=c4c547ca"
import script from "./CustomReportsCrud.vue?vue&type=script&lang=js"
export * from "./CustomReportsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports